import axios from 'axios';
import { IStatistics } from 'app/models/statistics.models';

const basePath = '/statistics';

export const statisticsService = {
  getStatistics: (role: string): Promise<IStatistics> => axios.get(`${basePath}/${role}`),
};
